import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import WelcomePage from "@/components/WelcomePage";
import LavagePage from "@/components/LavagePage";
import ScellantPage from "@/components/ScellantPage";
import FixedHeader from "@/components/FixedHeader";
import FloatingCallButton from "@/components/FloatingCallButton";

const Home = () => {
  const [currentView, setCurrentView] = useState('welcome');

  const handleEnterSite = () => {
    setCurrentView('lavage');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigation = (target) => {
    if (target === 'home') {
      setCurrentView('welcome');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (target === 'lavage') {
      setCurrentView('lavage');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (target === 'scellant') {
      setCurrentView('scellant');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // Welcome / splash page
  if (currentView === 'welcome') {
    return <WelcomePage onEnterSite={handleEnterSite} />;
  }

  // Lavage page (primary service)
  if (currentView === 'lavage') {
    return (
      <>
        <FixedHeader onNavigate={handleNavigation} currentPage="lavage" />
        <LavagePage onNavigate={handleNavigation} />
        <FloatingCallButton />
      </>
    );
  }

  // Scellant page
  if (currentView === 'scellant') {
    return (
      <>
        <FixedHeader onNavigate={handleNavigation} currentPage="scellant" />
        <ScellantPage />
        <FloatingCallButton />
      </>
    );
  }

  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
